// /app/frontend/src/api/innerWork.js
// Inner Work API client - Uses the shared axios instance
import client from "./client";

export async function getTodayPrompt() {
  const res = await client.get("/inner-work/prompt/today");
  return res.data; // null or prompt object
}

export async function createReflection(payload) {
  // payload: { prompt_id?: string, reflection_text: string, feeling_tag?: string, clarity_score?: number }
  const res = await client.post("/inner-work/reflections", payload);
  return res.data;
}

export async function listReflections({ limit = 50, before = null } = {}) {
  const params = { limit };
  if (before) params.before = before;
  const res = await client.get("/inner-work/reflections", { params });
  return res.data; // array
}

export async function getReflection(reflectionId) {
  const res = await client.get(`/inner-work/reflections/${reflectionId}`);
  return res.data;
}

export async function updateReflection(reflectionId, payload) {
  const res = await client.patch(`/inner-work/reflections/${reflectionId}`, payload);
  return res.data;
}

export async function deleteReflection(reflectionId) {
  const res = await client.delete(`/inner-work/reflections/${reflectionId}`);
  return res.data;
}

export async function shareReflection(reflectionId, payload) {
  // payload: { share_type, room_id?, match_id?, message_id?, snippet_text? }
  const res = await client.post(`/inner-work/reflections/${reflectionId}/share`, payload);
  return res.data;
}

export async function monthStats({ year, month }) {
  const res = await client.get("/inner-work/stats/month", { params: { year, month } });
  return res.data;
}
